export enum HOUSE_PROFILE {
  CONSUMPTION = "Consumption",
  CONSUMPTION_ES = "ConsumptionES",
  MICROGENERATION = "Microgeneration",
  SELF_CONSUMPTION = "Selfconsumption",
  COMMUNITY_CONSUMPTION = "CommunityConsumption",
  COMMUNITY_PRODUCTION = "CommunityProduction",
  COMMUNITY_SELFCONSUMPTION = "CommunitySelfconsumption",
  STORAGE = "Storage",
}

export enum PERMISSION_ROLE {
  ADMIN = "Admin",
  User = "User",
}

export enum HOUSE_TARIFF {
  SIMPLE = "simple",
  BI = "bi",
  TRI = "tri",
}

export enum HOUSE_CYCLE {
  DAILY = "daily",
  WEEKLY = "weekly",
}

export enum HOUSE_CLASSIFICATIONS {
  B2C = "B2C",
  B2B = "B2B",
}

export enum HOUSE_SERVICE_PROVIDERS {
  PORTUGAL = "PT",
  SPAIN = "ES",
  SPAIN_TOTAL = "ES-TOTAL",
  BRAZIL = "BR",
}

export enum HOUSE_COUNTRIES {
  PORTUGAL = "Portugal",
  SPAIN = "Spain",
  BRAZIL = "Brazil",
}

export enum HOUSE_GEOGRAPHY {
  PORTUGAL = "PT",
  SPAIN = "ES",
}

export enum HOUSE_STATUS {
  NOT_INITIALIZED = "notInitialized",
  ACTIVE = "active",
  SUSPENDED = "suspended",
  DEACTIVATED = "deactivated",
}

export enum HOUSE_BILLING_PERIOD {
  MONTHLY = "monthly",
  BIMONTHLY = "bimonthly",
  ANUAL = "annual",
}



// WEBPACK FOOTER //
// ./src/app/entities/houses/houses.constants.ts